
import React from "react";

interface TableStatusBadgeProps {
  isPublic: boolean;
}

export function TableStatusBadge({ isPublic }: TableStatusBadgeProps) {
  if (isPublic) {
    return (
      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
        Δημόσιο
      </span>
    );
  }
  
  return (
    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
      Ιδιωτικό
    </span>
  );
}
